import {Generics, verticalPage} from "./generics.ts";
import {create} from "../../fjsc/src/f2.ts";

export class Socials {
    static page() {
        return Generics.pageFrame(
            true,
            verticalPage(
                create("h1")
                    .text("Socials")
                    .build(),
                Socials.social("/images/services/youtube.png", "https://www.youtube.com/@sayosbagels"),
                Socials.social("/images/services/instagram.png", "https://www.instagram.com/sayosbagels/"),
                Socials.social("/images/services/tiktok.png", "https://www.tiktok.com/@sayos.bagels"),
            )
        );
    }

    static social(image: string, link: string) {
        return create("a")
            .classes("social")
            .href(link)
            .target("_blank")
            .children(
                create("img")
                    .classes("social-image")
                    .src(image)
                    .build()
            ).build();
    }
}